"use client";

import { c as _c } from "react/compiler-runtime";
import { useComment } from "@/components/Comment/context/comment.context";
import { useComments } from "@/components/Comment/context/comments.context";
import { ChatBubbleIcon } from "@/components/Icons/components/HeroIcons/ChatBubbleIcon.component";
import { Translation } from "@/components/Translation/Translation.component";
export function ReplyButton() {
  const $ = _c(4);
  const {
    thread
  } = useComment();
  const {
    hasActiveSubscription,
    isLoggedIn,
    isClosed,
    hasValidUserName
  } = useComments();
  if (isClosed || !isLoggedIn || !hasActiveSubscription || !hasValidUserName) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ChatBubbleIcon className="size-2 group-hover:text-primary group-focus-visible:text-primary" />;
    t1 = <Translation da="Svar" de="Antworten" en="Reply" no="Svar" sv="Svara" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== thread.openReplyForm) {
    t2 = <button aria-label="Reply to comment" className="group flex items-center justify-center gap-1 text-[12px] text-dim leading-none hover:text-primary focus-visible:text-primary focus-visible:outline-none" data-testid="comment-reply-btn" onClick={thread.openReplyForm} type="button">{t0}{t1}</button>;
    $[2] = thread.openReplyForm;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}